const STORAGE_KEY = "vh_admin_authenticated";
const MAX_AGE_MS = 8 * 60 * 60 * 1000;

export function setAdminSession() {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
}

export function clearAdminSession() {
  sessionStorage.removeItem(STORAGE_KEY);
}

export function isAdminAuthenticated() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return false;
  const t = parseInt(raw, 10);
  if (Number.isNaN(t)) return false;
  return Date.now() - t < MAX_AGE_MS;
}
